// components/onboarding/SignupGate.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Users, Briefcase, TrendingUp, Award } from 'lucide-react';

const SignupGate = ({ intendedDestination, onClose }) => {
  const navigate = useNavigate();

  const benefits = [
    {
      icon: Briefcase,
      title: 'Weekend work pays professional wages',
      description: 'Earn $30-50/hour using your existing skills'
    },
    {
      icon: Shield,
      title: 'Your skills are valued and verified',
      description: 'Build trust and unlock better opportunities'
    },
    {
      icon: TrendingUp,
      title: 'Save 25-40% on groceries',
      description: 'Join group buys with your neighbors'
    },
    {
      icon: Award,
      title: 'Build trust that unlocks opportunities',
      description: 'Higher trust scores mean better jobs'
    },
    {
      icon: Users,
      title: 'Keep money in YOUR community',
      description: 'Every purchase creates local jobs'
    }
  ];

  const handleSignup = () => {
    // Store intended destination for after signup
    localStorage.setItem('intendedDestination', intendedDestination);
    navigate('/register');
  };

  const handleLogin = () => {
    // Store intended destination for after login
    localStorage.setItem('intendedDestination', intendedDestination);
    navigate('/login');
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
      
      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl w-full max-w-lg transform transition-all">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-6 rounded-t-lg">
            <h2 className="text-2xl font-bold mb-2">
              Join Our Community to Unlock Opportunities
            </h2>
            <p className="text-blue-100">
              UniLedge is more than jobs - it's a movement where your skills create prosperity
            </p>
          </div>
          
          {/* Content */}
          <div className="p-6">
            <div className="space-y-4 mb-6">
              {benefits.map((benefit, index) => {
                const Icon = benefit.icon;
                return (
                  <div key={index} className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Icon className="text-blue-600" size={20} />
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-900">
                        {benefit.title}
                      </h3>
                      <p className="text-sm text-gray-600 mt-0.5">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Stats */}
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <div className="text-2xl font-bold text-blue-600">$30-50</div>
                  <div className="text-xs text-gray-600">Per Hour</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-green-600">25-40%</div>
                  <div className="text-xs text-gray-600">Savings</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-purple-600">1000+</div>
                  <div className="text-xs text-gray-600">Members</div>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="space-y-3">
              <button
                onClick={handleSignup}
                className="w-full py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
              >
                Join Free in 2 Minutes
              </button>
              
              <div className="text-center">
                <span className="text-sm text-gray-600">Already a member? </span>
                <button
                  onClick={handleLogin}
                  className="text-sm text-blue-600 hover:text-blue-700 font-medium"
                >
                  Sign in
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupGate;